// Corresponding React/Tailwind Structure (using existing components)
// src/sections/Stats/StatsSection.tsx
import React from "react";
import StatsCounter from "../../components/StatsCounter/StatsCounter"; // Adjust path if needed
import bannerBg from "../../assets/img/banner-bg.jpg"; // Import the image
const StatsSection: React.FC = () => {
  const statsData = [
    { id: "years", endValue: 12, label: "Years Helping Business", suffix: "+" },
    { id: "tech", endValue: 10, label: "Technologies", suffix: "+" },
    { id: "domains", endValue: 5, label: "Domains", suffix: "+" },
    { id: "projects", endValue: 50, label: "Complete Projects", suffix: "+" },
  ];

  return (
    // Equivalent to <section class="counter-area section-padding">
    <section className="relative py-6 bg-gray-900 overflow-hidden">
      {/* Background image from image_330f9c.jpg */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-60"
        style={{
          backgroundImage: `url('${bannerBg}')`,
        }} // Replace with actual path
      ></div>

      {/* Equivalent to <div class="container"> */}
      <div className="relative z-10 max-w-10xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Equivalent to <div class="row"> with Bootstrap column classes */}
        {/*
          Bootstrap: col-lg-3 col-md-6
          - On large (lg) screens: 12 / 3 = 4 columns (each item takes 1/4 width)
          - On medium (md) screens: 12 / 6 = 2 columns (each item takes 1/2 width)
          - On small (sm) and extra small (xs) screens: defaults to 1 column (each item takes full width)
        */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {statsData.map((stat) => (
            // The StatsCounter component already encapsulates the "single-counter" and "counter-contents" structure
            // and applies the H2/H3 styling.
            // The "counter-item" class equivalent is handled by the grid layout.
            <StatsCounter
              key={stat.id}
              endValue={stat.endValue}
              label={stat.label}
              suffix={stat.suffix}
              duration={2500} // Example duration
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
